import LoginBase from "./components/Base";

export default function LoginFeature() {
  return (
    <div>
      <LoginBase />
    </div>
  );
}
